import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardBody, CardHeader } from 'reactstrap';
import { Badge } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getWaterRightsListQuery } from '../../slices/waterRights/thunk';
import { Link } from 'react-router-dom';
import { getRolesList } from '../../slices/thunks';
import { ODataGrid } from '../../Components/OElements/ODataGrid';
import DeleteWaterRightsModal from './Modals/DeleteWaterRights';
import AddWaterRightDocumentModal from './Modals/AddWaterRightDocumentModal';
import AddWaterRightHistoryModal from './Modals/AddWaterRightHistoryModal';
import AddWorkModal from './Work/Modals/AddWorkModal';
import { Icons } from '../../utils/Icons';
import WaterRightDetailRow from './DetailPanels/WaterRightDetailRow';

const WaterRigthsList = () => {

	const dispatch = useDispatch();
	const history = useNavigate();
	const [dataWaterRights, setDataWaterRights] = useState({});
	const [refetchGrid, setRefetchGrid] = useState(0);

	// Delete WaterRights
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);

	// Document Upload Modal
	const [modalDocument, setModalDocument] = useState(false);
	const [selectedWaterRight, setSelectedWaterRight] = useState(null);

	// Procedure History Modal
	const [modalHistory, setModalHistory] = useState(false);
	const [selectedWaterRightHistory, setSelectedWaterRightHistory] = useState(null);

	// Work Configuration Modal
	const [modalWork, setModalWork] = useState(false);
	const [selectedWaterRightForWork, setSelectedWaterRightForWork] = useState(null);

	// Helper function to format dates
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return '-';
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	};


	const selectorWaterRights = createSelector(
		state => state.WaterRights,
		water_rights => ({
			water_rightsList: water_rights?.waterRightsList,
			isLoadingList: water_rights?.isLoadingList,
			isWaterRightsSuccess: water_rights?.isWaterRightsSuccess,
			error: water_rights?.error,
			isAdding: water_rights?.isAdding,
			isAdded: water_rights?.isAdded,
			isAddError: water_rights?.isAddError,
			isUpdating: water_rights?.isUpdating,
			isUpdated: water_rights?.isUpdated,
			isUpdateError: water_rights?.isUpdateError,
			isDeleting: water_rights?.isDeleting,
			isDeleted: water_rights?.isDeleted,
			isDeleteError: water_rights?.isDeleteError,
		})
	);

	const { water_rightsList, isLoadingList } = useSelector(selectorWaterRights);

	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		// toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = water_rights => {
		setDataWaterRights(water_rights);
		setModalDelete(true);
	};

	// Document Upload Modal Toggle
	function handleToggleDocumentModal() {
		setModalDocument(!modalDocument);
		if (modalDocument) {
			setSelectedWaterRight(null);
		}
	}

	// Handle Document Upload Button Click
	const handleClickUploadDocument = water_right => {
		setSelectedWaterRight(water_right);
		setModalDocument(true);
	};

	// Procedure History Modal Toggle
	function handleToggleHistoryModal() {
		setModalHistory(!modalHistory);
		if (modalHistory) {
			setSelectedWaterRightHistory(null);
		}
	}

	// Handle Procedure History Button Click
	const handleClickRegisterHistory = water_right => {
		setSelectedWaterRightHistory(water_right);
		setModalHistory(true);
	};

	// Work Configuration Modal Toggle
	function handleToggleWorkModal() {
		setModalWork(!modalWork);
		if (modalWork) {
			setSelectedWaterRightForWork(null);
		}
	}

	// Handle Work Configuration Button Click
	const handleClickConfigureWork = water_right => {
		setSelectedWaterRightForWork(water_right);
		setModalWork(true);
	};

	// Update Data
	const handleClickEdit = water_rights => {
		history(`/water-right/register/${water_rights._id}`, { 
			state: { 
				waterRightData: water_rights,
				isEdit: true 
			} 
		});
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'actions',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					const rowData = cellProps.row.original;
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<a
												title={'Editar'}
												href='#'
												onClick={e => {
													e.preventDefault();
													handleClickEdit(rowData);
												}}
												style={{ cursor: 'pointer' }}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</a>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Configurar Obra'}
												to='#'
												onClick={() => handleClickConfigureWork(rowData)}
											>
												<i className={`${Icons.settings} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Cargar Documento Asociado'}
												to='#'
												onClick={() => handleClickUploadDocument(rowData)}
											>
												<i className={`${Icons.cloudUpload} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Registrar Historial de Trámites'}
												to='#'
												onClick={() => handleClickRegisterHistory(rowData)}
											>
												<i className={`${Icons.history} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={() => handleClickDelete(rowData)}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Estado DAA',
				dataType: 'select',
				accessorKey: 'water_rights_status.name',
				Cell: cellProps => {
					const status = cellProps.row.original.water_rights_status?.name;
					const getStatusColor = status => {
						if (!status) return 'gray';
						if (status.toLowerCase().includes('otorgado')) return 'green';
						if (status.toLowerCase().includes('trámite')) return 'yellow';
						if (status.toLowerCase().includes('caducado') || status.toLowerCase().includes('cancelado')) return 'red';
						return 'cyan';
					};
					return (
						<Badge color={getStatusColor(status)} tt='capitalize'>
							{status || '-'}
						</Badge>
					);
				},
			},
			{
				header: 'Unidad de Cultivo',
				dataType: 'select',
				accessorKey: 'establishment.name',
			},
			{
				header: 'Código de Expediente',
				dataType: 'string',
				accessorKey: 'file_number',
			},
			{
				header: 'Región',
				dataType: 'select',
				accessorKey: 'region.name',
			},
			{
				header: 'Comuna',
				dataType: 'select',
				accessorKey: 'commune.name',
			},
			{
				header: 'Empresa',
				dataType: 'select',
				accessorKey: 'company.name',
			},
			{
				header: 'N° Resolución DAA',
				dataType: 'string',
				accessorKey: 'resolution_number',
			},
			{
				header: 'Fecha Resolución DAA',
				dataType: 'date',
				accessorKey: 'resolution_date',
				Cell: cellProps => {
					return <span>{formatDate(cellProps.row.original.resolution_date)}</span>;
				},
			},
			{
				header: 'Tipo Derecho',
				dataType: 'select',
				accessorKey: 'water_right_type.name',
				Cell: cellProps => {
					const type = cellProps.row.original.water_right_type?.name;
					const color = type?.toLowerCase().includes('consuntivo') ? 'blue' : 'cyan';
					return (
						<Badge color={color} tt='capitalize'>
							{type || '-'}
						</Badge>
					);
				},
			},
			{
				header: 'Tipo de Fuente',
				dataType: 'select',
				accessorKey: 'water_source_type.name',
			},
			{
				header: 'Tipo de Uso',
				dataType: 'select',
				accessorKey: 'water_use_type.name',
			},
			{
				header: 'Estado de Uso',
				dataType: 'select',
				accessorKey: 'water_use_status.name',
				Cell: cellProps => {
					const status = cellProps.row.original.water_use_status?.name;
					const getColor = status => {
						if (!status) return 'gray';
						if (status.toLowerCase().includes('en uso')) return 'green';
						if (status.toLowerCase().includes('sin uso')) return 'yellow';
						return 'cyan';
					};
					return (
						<Badge color={getColor(status)} tt='capitalize'>
							{status || '-'}
						</Badge>
					);
				},
			},
			{
				header: 'Ubicación de Instalación',
				dataType: 'select',
				accessorKey: 'installation_location',
				Cell: cellProps => {
					const locations = cellProps.row.original.installation_location;
					if (!Array.isArray(locations) || locations.length === 0) return '-';
					return <span>{locations.map(l => l.name).join(', ')}</span>;
				},
			},
			{
				header: 'Fuente de Agua',
				dataType: 'multi-select',
				accessorKey: 'water_sources',
				Cell: cellProps => {
					const sources = cellProps.row.original.water_source;
					if (!Array.isArray(sources) || sources.length === 0) return '-';
					return <span>{sources.map(ws => ws.name).join(', ')}</span>;
				},
			},
			{
				header: 'Caudal Promedio Anual',
				dataType: 'number',
				accessorKey: 'annual_average_flow_rate',
				Cell: cellProps => {
					const flow = cellProps.row.original.annual_average_flow_rate;
					const unit = cellProps.row.original.flow_rate_unit?.name;
					if (!flow) return '-';
					return <span>{flow} {unit || ''}</span>;
				},
			},
			{
				header: 'C.B.R',
				dataType: 'select',
				accessorKey: 'real_estate_registry.name',
			},
		],
		[formatDate, handleClickEdit, handleClickConfigureWork, handleClickDelete, handleClickUploadDocument, handleClickRegisterHistory]
	);

	// Master Detail Panel
	const renderDetailPanel = useCallback(({ row }) => {
		if (!row.getIsExpanded()) return null;
		return <WaterRightDetailRow row={row} />;
	}, []);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody className='pt-3'>
							<ODataGrid
								columns={columns}
								getDataFunc={getWaterRightsListQuery}
								baseFilters={{
									disable: {
										$eq: false,
									},
								}}
								queryPopulate={[
									'establishment',
									'water_rights_status',
									'water_right_type',
									'water_source_type',
									'water_use_type',
									'water_use_status',
									'installation_location',
								    'water_source',
									'flow_rate_unit',
									'real_estate_registry',
									'region',
									'commune',
									'province',
									'company',
								]}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											history('/water-right/register');
										},
										title: 'Registrar Derechos de Agua'
									}
								]}
								nameFile={'derechos_de_agua'}
								masterDetailComponent={renderDetailPanel}
								getRowIdTable={(row) => row._id}						
								refetchRemoteData={refetchGrid}							
								/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<DeleteWaterRightsModal
				dataWaterRights={dataWaterRights}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
				toggleRefetch={() => setRefetchGrid(prev => prev + 1)}
			/>

			{selectedWaterRight && (
				<AddWaterRightDocumentModal
					waterRightData={selectedWaterRight}
					isOpen={modalDocument}
					handleToggleModal={handleToggleDocumentModal}
				/>
			)}

			{selectedWaterRightHistory && (
				<AddWaterRightHistoryModal
					waterRightData={selectedWaterRightHistory}
					isOpen={modalHistory}
					handleToggleModal={handleToggleHistoryModal}
				/>
			)}

			{selectedWaterRightForWork && (
				<AddWorkModal
					waterRightData={selectedWaterRightForWork}
					isOpen={modalWork}
					handleToggleModal={handleToggleWorkModal}
				/>
			)}
		</React.Fragment>
		
	);
};

export default WaterRigthsList;
